// @flow

/**
 * Shared display title component
 */

import styled from 'styled-components';

const DisplayTitle = styled.div`
  font-size: 0.85rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 0.5rem;
`;

export default DisplayTitle;
